import clsx from "clsx";
import React, { ReactNode } from "react";
import HoverArrowLink from "../HoverArrowLink";
import CustomLink from "../CustomLink";
import { LocationData } from "~/slices/LocationsSection";
import { Continent } from "./MapWrapper";

export default function SingleContinentMenuItem({
  continentName,
  activeContinent,
  updateContinentHandler,
  description = "",
  href,
  isLocationOverview = false,
  locations = [],
}: {
  continentName: string;
  activeContinent: string;
  updateContinentHandler: (continent: Continent) => void;
  description?: string;
  href: string;
  isLocationOverview?: boolean;
  locations?: LocationData[];
}) {
  if (
    isLocationOverview &&
    (!Array.isArray(locations) || locations.length === 0)
  )
    return null;
  return (
    <button
      onClick={() => updateContinentHandler(continentName as Continent)}
      // First because of reverse
      className={clsx("flex-col gap-1", activeContinent === continentName && "lg:pb-2")}
    >
      <ContinentTitle
        className={clsx([
          "relative w-fit cursor-pointer text-heading-6 text-white transition-opacity hover:opacity-100",
          activeContinent !== continentName && "opacity-60",
        ])}
      >
        {continentName}
      </ContinentTitle>

      <div
        className={`${
          activeContinent === continentName ? "items-visible" : "items-hidden"
        } lg:block`}
      >
        {isLocationOverview && Array.isArray(locations) ? (
          <ul
            className={clsx(
              "mt-2 justify-start gap-2 md:grid-cols-2 md:gap-x-8 md:gap-y-2 lg:grid-cols-1",
              continentName === "All facilities" ? "hidden" : "grid",
            )}
          >
            {locations.map((location, i) => {
              if (!location.name && !location.country) return null;
              return (
                <CustomLink
                  key={i}
                  to={location.link}
                  className="group opacity-60 transition-opacity hover:opacity-100"
                >
                  <span className="flex items-start gap-2 text-left text-white">
                    <span className="translate-z-0">
                      <HoverArrowLink
                        className="w-5 shrink-0 translate-y-0.5"
                        arrowClass="stroke-white"
                        direction="right"
                      />
                    </span>
                    <span>
                      {location.name}
                      {location.name && location.country && ", "}
                      {location.country}
                    </span>
                  </span>
                </CustomLink>
              );
            })}
          </ul>
        ) : (
          <>
            <p
              className={clsx([
                "text-left text-body transition-opacity duration-scalingCursor",
                activeContinent == continentName ? "opacity-80 " : "opacity-0 ",
              ])}
            >
              {description}
            </p>
            <CustomLink
              to={href}
              className={clsx([
                "group mt-4 flex w-fit items-center gap-2 text-body transition-opacity duration-scalingCursor",
                activeContinent == continentName ? "opacity-100" : "opacity-0",
              ])}
            >
              <>
                <HoverArrowLink
                  className="h-4 w-4"
                  arrowClass="stroke-white"
                  direction="right"
                />
                See all facilities
              </>
            </CustomLink>
          </>
        )}
      </div>
    </button>
  );
}

function ContinentTitle({
  children,
  className,
}: {
  children: ReactNode;
  className: string;
}) {
  return <h2 className={className}>{children}</h2>;
}
